import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

interface MileageBadgeProps {
  miles: number;
  type: 'loaded' | 'unloaded';
  simplified?: boolean;
}
export function MileageBadge({
  miles,
  type,
  simplified = false,
}: MileageBadgeProps) {
  const symbol = type === 'loaded' ? 'L' : 'UL';
  const formattedMiles = miles === 0 ? 0 : miles.toFixed(1);

  return (
    <div className="ml-1" data-testid={`${type}-mileage-badge`}>
      <Badge
        label={
          simplified
            ? `${symbol}${formattedMiles}`
            : `${formattedMiles} ${type} miles`
        }
        color="blue"
      />
    </div>
  );
}
